import React, { useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { useContext } from 'react';
import { CategoryRevenueBenchmarkContext } from 'contexts/CategoryRevenueBenchmark';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const RevenueWithinBenchmarkExplore = () => {
	const { gridData } = useContext(CategoryRevenueBenchmarkContext);
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of categories with spend less than median benchmarks (category spend as % of total revenue).`}
				</AnalysisDescription>
				<TableContainer>
					<AgGridTable gridOptions={gridData} gridStyle={gridStyle} />
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default RevenueWithinBenchmarkExplore;
